import {
  NewspaperIcon,
  BuildingOfficeIcon,
  PresentationChartLineIcon,
  QrCodeIcon,
  UsersIcon,
  TicketIcon,
  PrinterIcon,
  IdentificationIcon,
} from "@heroicons/react/24/solid";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import { ActiveEmployees } from "./EmployeeReports/ActiveEmployeeList";
import { ActiveEmployeesNoEmailAddress } from "./EmployeeReports/NoEmailAddress";
import { ActiveEmployeesAtClosedLocation } from "./EmployeeReports/ClosedLocation";
import { EmployeesWithTerminatedSupervisors } from "./EmployeeReports/EmployeesWithTerminatedSupervisors";
import { ActiveTempReport } from "./EmployeeReports/ActiveTempReport";
import CarrierAgreementReports from "./AgreementReports/CarrierAgreementReports";
import { AllOpenOffices } from "./OfficeReports/AllOpenOffices";
import { OfficeHoursReport } from "./OfficeReports/OfficeHoursReport";
import { OfficeHierarchyReport } from "./OfficeReports/OfficeHierarchyReport";
import { BillsOfficeHierarchyReport } from "./OfficeReports/BillsOfficeHierarchyReport";
import { DigitalAssetsReport } from "./DigitalAssetReport/DigitalAssetsReport";
import CAMSReports from "./ProducerCodeReports/CAMSReports";
import { NoEmployeeId } from "./EmployeeReports/NoEmployeeId";
import { DarkOffices } from "./OfficeReports/DarkOffices";
import { AllOfficesStatus } from "./OfficeReports/AllOfficesStatus";
import { ScorecardReportDaily } from "./ScorecardReport/ScorecardReportDaily";
import { ScorecardReportClosed } from "./ScorecardReport/ScorecardReportClosed";
import { ScorecardReportOpen } from "./ScorecardReport/ScorecardReportOpen";
import { BusinessLicensesPermitsReport } from "./BusinessLicensesPermitsReport/BusinessLicensesPermitsReport";
import { BusinessLicensesPermitsReportWestBU } from "./BusinessLicensesPermitsReport/BusinessLicensesPermitsReportWestBU";
import { LeasedEquipmentReport } from "./LeasedEquipmentReport/LeasedEquipmentReport";
import { PendingTerminationReport } from "./EmployeeReports/PendingTerminationReport";
import { CDRCExceptionReport } from "./ProducerCodeReports/CDRCExceptionReport";
import { SPLCOfficesReport } from "./OfficeReports/SPLCOfficesReport";
import { SalesOperationsReport } from "./OfficeReports/SalesOperationsReport";
import { SalesforceAllOffices } from "./OfficeReports/SalesforceAllOffice";
import { SnowflakeReport } from "./ProducerCodeReports/SnowflakeReport";
import { AL3Report } from "./ProducerCodeReports/AL3Report";
import { CarrierEAndOReports } from "./CarrierReport/CarrierEAndOReports";
import { CarrierEAndOPerStateReports } from "./CarrierReport/E&OContactPerState/CarrierEAndOPerStateReports";

export const SidebarData = [
  {
    title: "Producer Codes",
    icon: <QrCodeIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_carrieragreemnentmgmt_report_view,
    subNav: [
      {
        title: "Carrier State Office Codes",
        path: ROUTE_PATHS.CSOPC_Reports,
        component: CAMSReports,
        permission: PERMISSIONS.permission_carrieragreemnentmgmt_report_view,
      },
      // {
      //   title: "CDRC Exception Report",
      //   path: ROUTE_PATHS.Exception_Reports,
      //   component: ExceptionReport,
      //   permission: PERMISSIONS.permission_carrieragreemnentmgmt_report_view,
      // },
      {
        title: "CDRC Exception Report",
        path: ROUTE_PATHS.MappedToCDRC_Reports,
        component: CDRCExceptionReport,
        permission: PERMISSIONS.permission_carrieragreemnentmgmt_report_view,
      },
      {
        title: "Tableau - All Data Report",
        path: ROUTE_PATHS.Snowflake_Reports,
        component: SnowflakeReport,
        permission: PERMISSIONS.permission_report_allsnowflakes_view,
      },
      {
        title: "AL3 Exception Data Report",
        path: ROUTE_PATHS.AL3_Reports,
        component: AL3Report,
        permission: PERMISSIONS.permission_report_allal3_view,
      },
    ],
  },
  {
    title: "Carrier",
    icon: <PrinterIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_report_carrier_view,
    subNav: [
      {
        title: "E&O Contact Report",
        path: ROUTE_PATHS.CarrierEAndO_Reports_Index,
        component: CarrierEAndOReports,
        permission: PERMISSIONS.permission_report_carrier_eandocontact_view,
      },
      {
        title: "E&O Contact Report Per State",
        path: ROUTE_PATHS.CarrierEAndOPerState_Reports_Index,
        component: CarrierEAndOPerStateReports,
        permission:
          PERMISSIONS.permission_report_carrier_eandocontactperstate_view,
      },
    ],
  },
  {
    title: "Agreement",
    icon: <NewspaperIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_agreement_reports_view,
    subNav: [
      {
        title: "Carrier Agreements",
        path: ROUTE_PATHS.Carrier_Reports,
        component: CarrierAgreementReports,
        permission: PERMISSIONS.permission_agreement_reports_view,
      },
    ],
  },
  {
    title: "Office",
    icon: <BuildingOfficeIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_report_office_view,
    subNav: [
      {
        title: "All Open Office",
        path: ROUTE_PATHS.AllOpenOffices_Reports,
        component: AllOpenOffices,
        permission: PERMISSIONS.permission_report_office_allopenoffice_view,
      },
      {
        title: "Dark Offices",
        path: ROUTE_PATHS.DarkOffices_Reports,
        component: DarkOffices,
        permission: PERMISSIONS.permission_report_office_darkreports_view,
      },
      {
        title: "All Offices – All Status",
        path: ROUTE_PATHS.AllOfficesStatus_Reports,
        component: AllOfficesStatus,
        permission: PERMISSIONS.permission_report_office_allstatusoffice_view,
      },
      {
        title: "Office Hours",
        path: ROUTE_PATHS.OfficeHours_Reports,
        component: OfficeHoursReport,
        permission: PERMISSIONS.permission_report_office_officehours_view,
      },
      {
        title: "Office Hierarchy",
        path: ROUTE_PATHS.OfficeHierarchy_Reports,
        component: OfficeHierarchyReport,
        permission: PERMISSIONS.permission_report_office_officehierarchy_view,
      },
      {
        title: "Bill’s Office Hierarchy Report",
        path: ROUTE_PATHS.BillsOfficeHierarchy_Reports,
        component: BillsOfficeHierarchyReport,
        permission:
          PERMISSIONS.permission_report_office_billsofficehierarchy_view,
      },
      {
        title: "Sales Operations Report",
        path: ROUTE_PATHS.SalesOperations_Reports,
        component: SalesOperationsReport,
        permission: PERMISSIONS.permission_report_office_salesoperations_view,
      },
      {
        title: "SPLC Offices Report",
        path: ROUTE_PATHS.SPLCOffices_Reports,
        component: SPLCOfficesReport,
        permission: PERMISSIONS.permission_report_office_splcoffices_view,
      },
      {
        title: "Salesforce-ALL Report",
        path: ROUTE_PATHS.SalesforceAll_Reports,
        component: SalesforceAllOffices,
        permission: PERMISSIONS.permission_report_office_salesforceall_view,
      },
    ],
  },
  {
    title: "Employees",
    icon: <UsersIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_carrieragreemnentmgmt_report_view,
    subNav: [
      {
        title: "Active Employees",
        path: ROUTE_PATHS.ActiveEmployees_Reports,
        component: ActiveEmployees,
        permission:
          PERMISSIONS.permission_report_employees_active_employee_view,
      },
      {
        title: "Active Employees No Email Address",
        path: ROUTE_PATHS.ActiveEmployeesNoEmailAddress_Report,
        component: ActiveEmployeesNoEmailAddress,
        permission:
          PERMISSIONS.permission_report_employees_active_employee_no_emailaddress_view,
      },
      {
        title: "Active Employees at Closed Locations",
        path: ROUTE_PATHS.ActiveEmployeesAtClosedLocations_Report,
        component: ActiveEmployeesAtClosedLocation,
        permission:
          PERMISSIONS.permission_report_employees_active_employee_closed_location_view,
      },
      {
        title: "Active Employees No Employee ID ",
        path: ROUTE_PATHS.ActiveEmployeesNoEmployeeId_Report,
        component: NoEmployeeId,
        permission:
          PERMISSIONS.permission_report_employees_active_employee_no_employeeid_view,
      },
      {
        title: "Employees with Terminated Supervisors",
        path: ROUTE_PATHS.EmployeesWithTerminatedSupervisors_Report,
        component: EmployeesWithTerminatedSupervisors,
        permission:
          PERMISSIONS.permission_report_employees_with_terminated_supervisor_view,
      },
      {
        title: "Active Temp Report",
        path: ROUTE_PATHS.ActiveTempReport_Report,
        component: ActiveTempReport,
        permission: PERMISSIONS.permission_report_employees_activetemp_view,
      },
      {
        title: "Pending Termination Report",
        path: ROUTE_PATHS.PendingTermination_Report,
        component: PendingTerminationReport,
        permission:
          PERMISSIONS.permission_report_employees_pending_termination_view,
      },
    ],
  },
  {
    title: "Marketing/Digital Assets",
    icon: <PresentationChartLineIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_report_digitalasset_digitalassetsreport_view,
    subNav: [
      {
        title: "Digital Assets Report",
        path: "/reportstab/reports/digital_assets_reports",
        component: DigitalAssetsReport,
        permission:
          PERMISSIONS.permission_report_digitalasset_digitalassetsreport_view,
      },
    ],
  },
  {
    title: "Leased Equipment",
    icon: <PrinterIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_leasedequipment_reports_view,
    subNav: [
      {
        title: "Leased Equipment Report",
        path: "/reportstab/reports/leased_equipment_report",
        component: LeasedEquipmentReport,
        permission: PERMISSIONS.permission_leasedequipment_reports_view,
      },
    ],
  },
  {
    title: "Scorecard",
    icon: <TicketIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_report_scorecard_scorecardreportsdaily_view,
    subNav: [
      {
        title: "Scorecard Report (Daily)",
        path: "/reportstab/reports/scorecardreportdaily",
        component: ScorecardReportDaily,
        permission:
          PERMISSIONS.permission_report_scorecard_scorecardreportsdaily_view,
      },
      {
        title: "Daily Scorecard Report (Closed)",
        path: "/reportstab/reports/scorecardreportclosed",
        component: ScorecardReportClosed,
        permission:
          PERMISSIONS.permission_report_scorecard_scorecardreportsclosed_view,
      },
      {
        title: "Open Scorecards >14 days",
        path: "/reportstab/reports/scorecardreportopen",
        component: ScorecardReportOpen,
        permission:
          PERMISSIONS.permission_report_scorecard_scorecardreportsopen_view,
      },
    ],
  },
  {
    title: "Business Licenses & Permits",
    icon: <IdentificationIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_report_businesslicensepermit_businesslicensespermitreports_view,
    subNav: [
      {
        title: "Business License Listing - ALL Confie",
        path: "/reportstab/reports/business_licenses_permits_report",
        component: BusinessLicensesPermitsReport,
        permission:
          PERMISSIONS.permission_report_businesslicensepermit_businesslicensespermitreportsall_view,
      },
      {
        title: "Business License Listing - West BU",
        path: "/reportstab/reports/business_licenses_permits_westBU_report",
        component: BusinessLicensesPermitsReportWestBU,
        permission:
          PERMISSIONS.permission_report_businesslicensepermit_businesslicensespermitreportswestbu_view,
      },
      ,
    ],
  },
];
